import React, {useState, useEffect, useRef} from 'react'
import {useLocation} from "react-router-dom";
import FromFieldText from '../../../atoms/FromFieldText';
import FromFieldDate from '../../../atoms/FromFieldDate';
import "react-datepicker/dist/react-datepicker.css";
import { getTransferDetailsByTinNo,getAllUploadDocByTin, saveUploadInitialApproval,} from '../../../services/transfer.service';
import * as CryptoJS from "crypto-js";
const TEXT_REGEX = /^[A-Za-z0-9-_/.@= ]{1,155}$/;



function UploadApproval() {
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const TinNo = query.get('tin_no');
    const elementRef = useRef();

    useEffect(() => {
        if (TinNo !== '' && TinNo !== null) {
            //getAssetsImagesInfo(Tag);
            //alert(Tag);
        }

    }, []);
    
        const [errMsg, setErrMsg] = useState('');
        const [assetInfo, setTransferInfo] = useState({});
        const [success, setSuccess] = useState(false);
        //const [allocate, setAllocate] = useState('');
        const [disabled, setDisabled] = useState(false);
        const [tinNo, setTinNo] = useState('');
        const [initTinNo, setInitTinNo] = useState('');
        const [ErrTinNo, setErrTinNo] = useState(false);
        const [NoOfDoc, setNoOfDoc] = useState('');
        const [ErrNoOfDoc, setErrNoOfDoc] = useState(false);
        const [uploadApprovalMails, setUploadApprovalMails] = useState([]);
        const [ErrUploadApprovalMails, setErrUploadApprovalMails] = useState(false);
        const [uploadApprovalMailCount, setUploadApprovalMailCount] = useState(0);
        const [allUploadApprovalMails, setAllUploadApprovalMails] = useState([]);
        const [uploadInitialApproval, setUploadInitialApproval] = useState([]);
        const [ErrUploadInitialApproval, setErrUploadInitialApproval] = useState(false);
        const [uploadInitialApprovalCount, setUploadInitialApprovalCount] = useState(0);
        const [allUploadDoc, setAllUploadDoc] = useState([]);
        const [imagelist, setImageList] = useState([]);
        const [uploadTransportDoc, setUploadTransportDoc] = useState([]);
        const [ErrUploadTransportDoc, setErrUploadTransportDoc] = useState(false);
        const [uploadTransportDocCount, setUploadTransportDocCount] = useState(0);
        const [allUploadTransportDoc, setAllUploadTransportDoc] = useState([]);
        const [imgFile, setImgFile] = useState([]);
        const maxInitialApprovalFiles = 3-uploadInitialApprovalCount; // Maximum number of files allowed
        const maxTransportDocFiles = 3-uploadTransportDocCount; // Maximum number of files allowed
        const maxApprovalMailFiles = 3-uploadApprovalMailCount; // Maximum number of files allowed
        
        const getTinNoInfo = function() { //resetTransferInfo();
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data':{'tin_no':tinNo},
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = {'token':EncryptData}
            getTransferDetailsByTinNo(oData).then(function(res){
                //console.log('res.data.data');
                //console.log(res.data.data);
                var aInfo={};var aInfo1=[];
                if(res?.data?.data.length) { setErrMsg('');
                    aInfo = res?.data?.data[0];
                    setTransferInfo(aInfo);
                    //setTransferId(aInfo.trans_id);
                    setInitTinNo(aInfo.tin_no);
                    aInfo1 = res?.data?.data1;
                    setImageList(aInfo1);
                }else{ //setTransferInfo({});
                     setErrMsg('Assets Not Found');
                    } 
            })
        }
        
        const getAssetsImagesInfo = function (Tag) {
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data':{'tin_no':TinNo},
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = {'token': EncryptData}
            getAllUploadDocByTin(oData).then(res => {
                if (res.status === 200) {
                    var data = res?.data?.data;
                    if (data.length) {
                        //console.log('getAllImagesByInvoice'); console.log(res.data.data);
                        setAllUploadDoc(data);
                    }
                }
            });
        }

        const handleUploadInitialApproval = (e) => {
            const files = e.target.files;
            let totalSize = 0;
            const maxFileSize = 5 * 1024 * 1024; // 5 MB in bytes
            setErrUploadInitialApproval('');
            // Check file size and count
            if (files.length > maxTransportDocFiles) {
                setErrUploadInitialApproval(`You can only upload a maximum of ${maxTransportDocFiles} files.`);
                return;
            }
            
            for (let i = 0; i < files.length; i++) {
                    
                totalSize += files[i].size;
                const file = files[i];
                if (totalSize > maxFileSize) {
                    setErrUploadInitialApproval(`File '${file.name}' exceeds the maximum file size limit of 5MB.`);
                    return;
                }else{
                    setImgFile((prev) => [...prev, { type: 'Initial_Approval', file: files[i] }]);
                    setUploadInitialApproval(i);
                }
            }
        };
        const handleUploadTransportDoc= (e) => {
            const files = e.target.files;
            let totalSize = 0;
            const maxFileSize = 3 * 1024 * 1024; // 5 MB in bytes
            // Check file size and count
            if (files.length > maxTransportDocFiles) {
                setErrUploadTransportDoc(`You can only upload a maximum of ${maxTransportDocFiles} files.`);
                return;
            }
            // Clear error if validations pass
            setErrUploadTransportDoc('');
            for (let i = 0; i < files.length; i++) {
                totalSize += files[i].size;
                const file = files[i];
                if (totalSize > maxFileSize) {
                    setErrUploadTransportDoc(`File '${file.name}' exceeds the maximum file size limit of 5MB.`);
    
                    return;
                }else{
                    setImgFile((prev) => [...prev, { type: 'Transport_Doc', file: files[i] }]);
                    setUploadTransportDoc(files[i]);
                }
            }
        };
        const handleUploadApprovalMail = (e) => {
            const files = e.target.files;
            let totalSize = 0;
            const maxFileSize = 5 * 1024 * 1024; // 5 MB in bytes
            // Clear error if validations pass
            setErrUploadApprovalMails('');
            // Check file size and count
            if (files.length > maxInitialApprovalFiles) {
                setErrUploadApprovalMails(`You can only upload a maximum of ${maxInitialApprovalFiles} files.`);
                return;
            }
            for (let i = 0; i < files.length; i++) {
                totalSize += files[i].size;
                const file = files[i];
                if (totalSize > maxFileSize) {
                    setErrUploadApprovalMails(`File '${file.name}' exceeds the maximum file size limit of 5MB.`);
                    return;
                }else{ // Set the files in state
                    setImgFile((prev) => [...prev, { type: 'Approval_Mails', file: files[i] }]);
                    setUploadApprovalMails(files[i]); 
                }
            }
        };
    
        // Calculate the remaining number of files
        const remainingIAFiles = maxInitialApprovalFiles - uploadInitialApproval.length;
        const remainingTDFiles = maxTransportDocFiles - uploadTransportDoc.length;
        const remainingAMFiles = maxApprovalMailFiles - uploadApprovalMails.length;
        const optionList = [];

        allUploadApprovalMails && allUploadApprovalMails.length > 0 ? (
            allUploadApprovalMails.map((option) => (
                optionList.push({value: option.tag, label: option.tag})
            ))
        ) : (
            optionList.push({value: "", label: "No Data"})
        )
        
        //subit invoice form
        const handleSubmit = async (e) => {
            e.preventDefault();
            var valid_Name = true; //alert(valid_Name);
            
            if(allUploadDoc.filter(option => option.asset_dimension === "Initial_Approval").length == 0){
                if (uploadInitialApproval ==  null || uploadInitialApproval == '') { 
                    //alert('uploadassetimage');
                    setErrUploadInitialApproval('Upload initial approval is required');
                    valid_Name = false;
                    //return;
                } else {
                    setErrUploadInitialApproval('');
                } 
            }else{ setErrUploadInitialApproval(''); }

            /*if(imgFile.length==0){
                setErrUploadMaxImage('Image is required');
                valid_Name = false;
            }else{ setErrUploadMaxImage(''); }*/

            if (valid_Name) { //alert('validName');
                saveData(); //submit form
            } else {
                //alert(valid_Name);
                return false;
            }
        }
        const resetAssetInfo = function () {
            //setTag('');
        }
        const saveData = function () {
            try {
                const formData = new FormData();
                var types = [];
                imgFile.forEach(({ file, type }, index) => {
                    formData.append("approval_doc[]", file);
                    //formData.append("dimension[]", type); // Store dimension or type as needed
                    //setImgTypes((prev) => [...prev,type]);
                    types.push(type);
                });
                let jsonData = {
                    'tin_no': tinNo,
                    'upload_dir': "branch_transfer_doc",
                    'doc_type': NoOfDoc,
                    'application_type':'Web',
                    'created_by': sessionStorage.getItem('LoggedInUserId'),
                    'companyshortname': sessionStorage.getItem("LoggedInCompanyShortName"),
                    'users':{ 
                        'company_id':sessionStorage.getItem('LoggedInCompanyId'),
                        'department_id':sessionStorage.getItem('LoggedInDepartmentId'),
                        'division_id':sessionStorage.getItem('LoggedInDivisionId'),
                    }
                }
                //console.log(oData);
                var objAudit = {'audit_module':'Upload Invoices','audit_method':'created','audit_tag':tinNo,'old_values':'','new_values':JSON.stringify(jsonData)}
                jsonData.audit_params = objAudit;
                jsonData.dimension = types;
                const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(jsonData), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                formData.append("metadata", encryptedData);   
                 
                saveUploadInitialApproval(formData, { 
                    headers: { 'Content-Type': 'multipart/form-data' }, }).then(function (res) {
                    if ((typeof (res.data.errors) !== "undefined") && res.data.errors.errno > 0) {
                        setErrMsg(res.data.message);
                        setSuccess(false);
                    } else {
                        setSuccess(res.data.message);
                        setDisabled(true);
                        setErrMsg(false);
                        //setErrTag('');
                        //resetAssetInfo();
                    }
                }).catch((error) => {
                    //console.error(error.response);
                    //this.setState({errormessage:error.response.statusText+" Please select the file"})
                    setErrMsg('No result');
                })
            } catch (err) {
                setSuccess(false);
                if (!err?.data) {
                    console.log(err);
                    setErrMsg('No Server Response');
                } else if (err.data?.status === 409) {
                    setErrMsg('Username Taken');
                } else {
                    setErrMsg('Insert/Update Failed');
                }
                //elementRef.current.focus();
            }
        }
    return (
        <div className="container">
            <div className="row">
                <div className="col"><h5>Upload Authorization</h5></div>
                <div className="invalid-feedback" role="alert">
                    <i className="fa fa-info-circle"></i>Please Fill all mandetory field.
                </div>
                {success ? (
				<div className="alert alert-success" role="alert"><i className="bi bi-check-circle-fill"></i>{success}</div>
			        ) : ( errMsg ? (<div className="alert alert-danger" role="alert"><i className="bi bi-exclamation-triangle-fill"></i>{errMsg}</div>):('')
                ) }
            </div>
            <div className='row '>
            <div className='col-12'>&nbsp;</div>
            {
            (TinNo!=='' && TinNo!==null) ? <div className='row'><div className='col-10'></div> <div className='col-2'></div></div> : <div className='row'><div className='col'><h5 className='align-right'>TIN No. </h5></div>
            <div className='col'><input onChange={function(event){setTinNo(event.target.value)}} inputValue={assetInfo.tin_no} type="text" className="form-control"  placeholder='Search TIN No' /><p className='invalid-feedback'>{ErrTinNo}</p></div>
            <div className='col'><button onClick={getTinNoInfo} className='btn btn-info btn-md'><i className="bi bi-search"></i> Search </button>&nbsp;<a href={'/update-transport-details' }><button  className='btn btn-secondary btn-md'><i className="bi bi-arrow-clockwise"></i> Reset</button></a>&nbsp;</div></div>
            }
            </div>
            <div className='row'></div>

            <div className="row mt-4">
                <div className="col-6">
                    <FromFieldText readOnly ="readOnly"
                        label="TIN No"
                        placeholder="TIN No"
                        inputValue={initTinNo}
                        //setInputValue={setTinNo}
                    />
                </div>
                <div className="col-6">
                </div>
            </div>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className='row single__asset__form'>
                <div className="col-6">
                <div className='row'>
                    <div className="col-6">
                        <div className="label col-6">
                            <label> Upload Initial approval </label>
                        </div>
                    </div>
                    <div className='col-6'>
                        <span className="invalid-feedback"> {ErrNoOfDoc} </span>
                        
                        <span className="star error">  </span>
                        {imagelist.filter(option => option.doc_type === "Initial_Approval").length > 0 ? (
                        <div>
                            <input type="file" name='Initial_Approval' multiple onChange={handleUploadInitialApproval} />
                            <span className="invalid-feedback"> {ErrUploadInitialApproval} </span>
                            </div>
                        
                        ):(
                            <div>
                                <input type="file" name='Initial_Approval' multiple onChange={handleUploadInitialApproval}/>
                                <span className="invalid-feedback"> {ErrUploadInitialApproval} </span>
                            </div>
                        )}
                        <p>Remaining attachments: {remainingIAFiles}</p>
                        
                    </div>
                </div>
                </div><div className='col-6'>&nbsp;</div>
            </div>
            <div className='row single__asset__form'>
                <div className="col-6">
                <div className='row'>
                    <div className="col-6">
                        <div className="label col-6">
                            <label> Upload Transport Document </label>
                        </div>
                    </div>
                    <div className='col-6'>
                        <span className="invalid-feedback"> {ErrNoOfDoc} </span>
                        {imagelist.filter(option => option.doc_type === "Transport_Doc").length > 0 ? (
                        <div>
                            <input type="file" name='Transport_Doc' multiple onChange={handleUploadTransportDoc} />
                            <span className="invalid-feedback"> {ErrUploadTransportDoc} </span>
                            </div>
                        
                        ):(
                            <div>
                                <input type="file" name='Transport_Doc' multiple onChange={handleUploadTransportDoc}/>
                                <span className="invalid-feedback"> {ErrUploadTransportDoc} </span>
                            </div>
                        )}
                        <p>Remaining attachments: {remainingTDFiles}</p>
                        
                    </div>
                </div>
                </div><div className='col-6'>&nbsp;</div>
            </div>
            <div className='row single__asset__form'>
                <div className="col-6">
                <div className='row'>
                    <div className="col-6">
                        <div className="label col-6">
                            <label> Upload Approval Mail </label>
                        </div>
                    </div>
                    <div className='col-6'>
                        <span className="invalid-feedback"> {ErrNoOfDoc} </span>
                        {imagelist.filter(option => option.doc_type === "Approval_Mails").length > 0 ? (
                        <div>
                            <input type="file" name='Approval_Mails' multiple onChange={handleUploadApprovalMail} />
                            <span className="invalid-feedback"> {ErrUploadApprovalMails} </span>
                            </div>
                        
                        ):(
                            <div>
                                <input type="file" name='Approval_Mails' multiple onChange={handleUploadApprovalMail}/>
                                <span className="invalid-feedback"> {ErrUploadApprovalMails} </span>
                            </div>
                        )}
                        <p>Remaining attachments: {remainingAMFiles}</p>
                        
                    </div>
                </div>
                </div><div className='col-6'>&nbsp;</div>
            </div>
            <div className='row save__button text-center'>
                <div className='col-md-8'>
                    {(TinNo !== '' && TinNo !== null) ? <div>
                            <button className="btn btn-primary btn-md">Update</button>
                            &nbsp;&nbsp;<a href={'/asset-details?tag=' + TinNo}
                                        className="btn btn-secondary btn-md">Cancel</a></div>
                        : <button id="btn-submit" className="btn btn-primary btn-md"
                                disabled={disabled}><i className="bi bi-upload"></i> UPLOAD </button>
                    }

                </div>
            </div>
            </form>


        </div>
    )
}

export default UploadApproval;